<template>
  <v-dialog v-model="show" width="50vw" scrollable persistent>
    <v-card height="auto" elevation="5" class="rounded-lg" min-height="200">
      <v-card-title class="text-h5 lighten-2">
        <span v-if="materialSelected"> Actualizar registro </span>
        <span v-else> Nuevo registro </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="formRawMaterial" lazy-validation>
            <v-row>
              <v-col cols="12" xl="6" lg="6" md="6">
                <v-text-field
                  type="date"
                  v-model="arrivalDate"
                  dense
                  :rules="validation('fecha de arribo', 'F')"
                  label="Fecha de arribo"
                  outlined
                  clearable
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" xl="6" lg="6" md="6">
                <v-autocomplete
                  v-model="materialType"
                  :items="types"
                  dense
                  no-data-text="Material no disponible"
                  :rules="validation('materia prima', 'F')"
                  label="Tipo de materia prima"
                  outlined
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" xl="6" lg="6" md="6">
                <v-text-field
                  type="number"
                  v-model="qty"
                  dense
                  :rules="validation('cantidad', 'F')"
                  label="Cantidad"
                  outlined
                  clearable
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" xl="6" lg="6" md="6">
                <v-autocomplete
                  v-model="unit"
                  :items="units"
                  dense
                  return-object
                  item-text="text"
                  :rules="validation('unidad', 'F')"
                  label="Unidad"
                  outlined
                  no-data-text="Unidad no disponible"
                  clearable
                ></v-autocomplete>
              </v-col>
              <!-- <v-col cols="12" xl="6" lg="6" md="6">
                <v-text-field
                  type="text"
                  v-model="annex"
                  dense
                  :rules="validation('anexo')"
                  label="Anexo"
                  outlined
                  clearable
                >
                </v-text-field>
              </v-col> -->
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col>
              <v-btn
                color="gray"
                block
                @click="closeModal"
                dark
                rounded
                :disabled="isLoading"
                >Cancelar</v-btn
              >
            </v-col>
            <v-col>
              <v-btn
                rounded
                color="primary"
                block
                @click="confirmation"
                :loading="isLoading"
                >Guardar</v-btn
              >
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Validations
import {
  requiredFValidation,
  requiredValidation,
} from "@/helpers/validations.js";
//vuex
import { mapActions, mapState } from "vuex";
export default {
  data: () => ({
    loader: false,
    isLoading: false,
    arrivalDate: null,
    materialType: null,
    qty: null,
    unit: null,
    // annex: null,
    units: [
      {
        text: "Kilogramos",
        value: "KG",
      },
      {
        text: "Litros",
        value: "L",
      },
    ],
    types: [
      "Aceite mineral",
      "Agromin 350",
      "Tween 20",
      "Almidón de maíz",
      "Fécula de papa",
      "Maltodextrina",
      "Caolín",
      "Arroz",
      "Melaza",
      "Ácido citrico",
      "Vegetarome",
      "Antiespumante",
      "Azúcar",
      "Caldo nutritivo",
      "Fosfato monopotasico",
      "Hidróxido de Potasio",
      "Leonardita",
      "Sal",
    ],
  }),
  props: {
    value: Boolean,
  },
  mounted() {
    if (this.materialSelected) {
      this.arrivalDate = this.materialSelected.arrivalDate;
      this.materialType = this.materialSelected.type;
      this.qty = this.materialSelected.quantity;
      // this.annex = this.materialSelected.annex;
      this.unit = this.materialSelected.unit;
    }
  },
  computed: {
    ...mapState("material", ["materialSelected"]),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    ...mapActions("material", ["addMaterial", "updateMaterial"]),
    closeModal() {
      this.show = false;
    },

    async confirmation() {
      //emit desision
      if (this.materialSelected) {
        try {
          if (this.$refs.formRawMaterial.validate()) {
            this.isLoading = true;
            let payload = {
              arrivalDate: this.arrivalDate,
              type: this.materialType,
              quantity: this.qty,
              unit: this.unit,
              // annex: this.annex,
              materialId: this.materialSelected._id,
            };

            let response = await this.updateMaterial(payload);
            if (!response && response.error) throw response;
            this.$swal({
              icon: "success",
              title: `Registro actualizado!`,
              showConfirmButton: false,
              timer: 2000,
            });
            this.$emit("confirmation");
            this.closeModal();
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Error al crear registro, intente de nuevo.`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      } else {
        try {
          if (this.$refs.formRawMaterial.validate()) {
            this.isLoading = true;
            let payload = {
              arrivalDate: this.arrivalDate,
              type: this.materialType,
              quantity: this.qty,
              unit: this.unit,
              // annex: this.annex,
            };

            let response = await this.addMaterial(payload);
            if (!response && response.error) throw response;
            this.$swal({
              icon: "success",
              title: `Registro guardado!`,
              showConfirmButton: false,
              timer: 2000,
            });
            this.$emit("confirmation");
            this.closeModal();
          }
        } catch (error) {
          console.log(error);
          this.$swal({
            icon: "error",
            title: `Error al crear registro, intente de nuevo.`,
            showConfirmButton: false,
            timer: 2000,
          });
        }
        this.isLoading = false;
      }
    },
    validation(name, type) {
      if (type === "F") {
        return requiredFValidation(name);
      } else {
        return requiredValidation(name);
      }
    },
  },
};
</script>
